import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css'; // core Swiper styles
import 'swiper/css/navigation'; // optional: if using modules like navigation
import { Navigation } from 'swiper/modules';
import "swiper/css";
import "swiper/css/navigation";
const CoreSlider = ({cards}) => {
  return (
    <div>
            <div className="position-relative mt-4">
       <Swiper
  modules={[Navigation]}
  navigation
  spaceBetween={20}
  loop
  breakpoints={{
    0: {
      slidesPerView: 1,
    },
    576: {
      slidesPerView: 1,
    },
    768: {
      slidesPerView: 2,
    },
    992: {
      slidesPerView: 3,
    },
  }}
  className="mySwiper px-md-4"
>
  {cards.map((card, index) => (
    <SwiperSlide
      key={index}
      className="d-flex justify-content-center align-items-center"
      style={{ maxHeight: 680 }}
    >
      <div className="text-center w-100">
        <img
          src={card.img}
          alt="Game screen"
          className="mb-3 img-fluid"
          style={{
            height: 'auto',
            maxHeight: 360,
            width: '80%',
            objectFit: 'cover',
          }}
        />
        <h3 className="fs-5 mb-2">{card.title}</h3>
        <p className="fs-6 lh-base">{card.desc}</p>
      </div>
    </SwiperSlide>
  ))}
</Swiper>
        </div>
    </div>
  )
}

export default CoreSlider